//Get Histories
import {
  GET_PAYROLL_HISTORY_REQUEST,
  GET_PAYROLL_HISTORY_SUCCESS,
  GET_PAYROLL_HISTORY_ERROR,
} from "../../actions/histories/getHistory";

//Logout
import { LOGOUT } from "../../../auth/actions/logout";

const INITIAL_STATE = {
  loading: false,
  error: false,
  data: [],
  pagination: {
    current_page: 0,
    last_page: 0,
    per_page: 0,
    total: 0,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PAYROLL_HISTORY_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case GET_PAYROLL_HISTORY_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        pagination: action.payload.pagination,
        error: false,
        loading: false,
      };
    case GET_PAYROLL_HISTORY_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loading: false,
      };
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};
